/*
This file is located in the main branch
Last time the file was updated (UTC): [25.11.2024 12:11:40]
Permissions to update outside the main branch: [false]
*/

import {
    DropDown,
    Id,
    Input,
    Money,
    PhoneNumber,
    WorkplaceBtnActions,
    WorkplaceBtnDelete,
} from '@finbeat/react-toolkit';
import DataTimeText from 'components/Common/DataTime';
import { FormatterProps } from 'react-data-grid';

export const checkboxFormatter = <TRow, TSummaryRow = unknown>(key: keyof TRow) => {
    const content = ({ row }: FormatterProps<TRow, TSummaryRow>) => (
        <Input type="checkbox" checked={!!row[key]} readOnly disabled />
    );

    return content;
};

export const deleteActionBtnFormatter = <TRow extends Id, TSummaryRow = unknown>(
    enabled: boolean
) => {
    const content = ({ row: { id } }: FormatterProps<TRow, TSummaryRow>) => (
        <WorkplaceBtnActions>
            {enabled && <WorkplaceBtnDelete key={`delete-btn-${id}`} id={id} />}
        </WorkplaceBtnActions>
    );

    return content;
};

type InferKey<T, P> = {
    [K in keyof T]: T[K] extends P ? K : never;
}[keyof T];

export const dateTimeFormatter = <TRow extends Record<string, any>, TSummaryRow = unknown>(
    key: InferKey<TRow, string | null | undefined>,
    format?: string | null
) => {
    const content = ({ row }: FormatterProps<TRow, TSummaryRow>) => (
        <DataTimeText value={row[key]} format={format} />
    );

    return content;
};

export const phoneNumberFormatter = <TRow extends Record<string, any>, TSummaryRow = unknown>(
    key: InferKey<TRow, string | number | null>
) => {
    const content = ({ row }: FormatterProps<TRow, TSummaryRow>) => (
        <PhoneNumber value={row[key]} />
    );

    return content;
};

export const moneyFormatter = <TRow extends Record<number | string, any>, TSummaryRow = unknown>(
    key: InferKey<TRow, number | string | null | undefined>
) => {
    const content = ({ row }: FormatterProps<TRow, TSummaryRow>) => <Money value={row[key]} />;

    return content;
};

export const dictValueFormatter = <TRow extends Record<string, any>, TSummaryRow = unknown>(
    key: InferKey<TRow, string | number | null | undefined>,
    dictionary: DropDown[]
) => {
    const content = ({ row }: FormatterProps<TRow, TSummaryRow>) => {
        const value = row[key];
        if (value === null || value === undefined) {
            return <></>;
        }
        const found = dictionary.find((d) => d.id === value);
        return <>{found?.name ?? value}</>;
    };
    return content;
};
